import { LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import Slider from "@ant-design/react-slick";
import React, { useRef } from "react";

const TopicItem = (props: any) => {
  const { banner } = props;
  let sliderHeader: any = useRef();
  let sliderFooter: any = useRef();

  const settings = {
    dots: false,
    infinite: true,
    speed: 800,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    // pauseOnHover: false,
  };

  const showSlide = (data: any) =>
    data.map((d: any, i: number) => (
      <img key={i} src={d.path} alt="" style={{ width: "100%" }} />
    ));

  const showDescription = (des: string, isPadding: boolean) => {
    return (
      <div
        style={{ padding: isPadding ? "0 10%" : 0 }}
        dangerouslySetInnerHTML={{
          __html: des,
        }}></div>
    );
  };

  return (
    <div style={{ backgroundColor: "#fff" }}>
      {banner?.images.length ? (
        <div className="slider-topic">
          {banner?.images[0].galaries.length > 1 ? (
            <a
              className="topic-arrow left"
              onClick={() => sliderHeader.slickPrev()}>
              <LeftCircleOutlined
                style={{
                  fontSize: "2rem",
                  color: "rgba(225,225,225, 0.5)",
                }}
              />
            </a>
          ) : null}
          <Slider {...settings} ref={(c) => (sliderHeader = c)}>
            {showSlide(banner.images[0].galaries || [banner?.img || []])}
          </Slider>
          {banner?.images[0].galaries.length > 1 ? (
            <a
              className="topic-arrow right"
              onClick={() => sliderHeader.slickNext()}>
              <RightCircleOutlined
                style={{
                  fontSize: "2rem",
                  color: "rgba(225,225,225, 0.5)",
                }}
              />
            </a>
          ) : null}
        </div>
      ) : null}

      <div style={{ marginTop: 25 }}>
        {showDescription(banner.description, banner.is_padding || false)}
      </div>

      {banner?.sub_images.length ? (
        <div className="slider-topic">
          {banner?.sub_images[0].galaries.length > 1 ? (
            <a
              className="topic-arrow left"
              onClick={() => sliderFooter.slickPrev()}>
              <LeftCircleOutlined
                style={{
                  fontSize: "2rem",
                  color: "rgba(225,225,225, 0.5)",
                }}
              />
            </a>
          ) : null}
          <Slider {...settings} ref={(c) => (sliderFooter = c)}>
            {showSlide(banner?.sub_images[0].galaries || [])}
          </Slider>
          {banner?.sub_images[0].galaries.length > 1 ? (
            <a
              className="topic-arrow right"
              onClick={() => sliderFooter.slickNext()}>
              <RightCircleOutlined
                style={{
                  fontSize: "2rem",
                  color: "rgba(225,225,225, 0.5)",
                }}
              />
            </a>
          ) : null}
        </div>
      ) : null}
    </div>
  );
};

export default TopicItem;
